<template>
  <v-tooltip :disabled="isNotDesktop" bottom>
    <template v-slot:activator="{ on }">
      <v-btn
          v-on="on"
          text
          icon
          @click="$emit('input', !value)"
          aria-label="volume"
          class="grid-btn"
      >
        <v-icon :color="$vuetify.theme.dark ? 'white' : 'grey'" small>
          {{ value === true ? 'apps' : 'fas fa-border-all' }}
        </v-icon>
      </v-btn>
    </template>
    <span> Dense Display </span>
  </v-tooltip>
</template>
<script>
export default {
  name: "ToggleDenseGrid",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isNotDesktop: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.grid-btn {
  //right: 180px;
  margin-top: 2px;
}
</style>